module.exports = __webpack_public_path__ + "img/297-5e1885.png";